import { ConfirmDialog } from './../../../ui/dialog/confirm/confirm.dialog';
import { cloneDeep } from 'lodash';
import { Router } from '@angular/router';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { Base64 } from '../../../utils/base64';
import { BasePage } from '../../base.page';
import {
    BaseProductInterface,
    ClientInterface,
    ContractInterface,
    GetAppropriatenessClientUseCase,
    GetOperationUseCase,
    GetOptimalSelectedProductUseCase,
    GetRoleNameUseCase,
    MifidCategoryCode,
    OrderInterface,
    OrderType,
    OrderTypeAvailableInterface,
    ProductInterface,
    RemoveSelectedProductsUseCase,
    RoleNameInterface,
    SelectedProductInterface,
    UpdateOperationUseCase,
    UpdateSelectedProductsUseCase,
    UserInterface,
} from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { Client, Id } from '../../../domain/data';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { OperativePage } from '../operative.page';
import { ParentEvents } from '../../../utils/parent-events.service';
import { TermsAndConditionsDialog } from '../../../ui/dialog/terms-and-conditions/terms-and-conditions.dialog';
import { AppConfig } from 'src/app/main/utils/app-config.service';
import moment from 'moment';
import { ConfirmTransferDialog } from 'src/app/main/ui/dialog/confirm-transfer/confirm-transfer.dialog';
import { delay } from 'rxjs/operators';

@Component({
    templateUrl: './operative-operate.page.html',
    styleUrls: ['./operative-operate.page.scss'],
})
export class OperativeOperatePage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    public OrderType: typeof OrderType = OrderType;

    private readonly backSubscription: Subscription;

    public allowedTypes: OrderTypeAvailableInterface[] = [];
    public contract: ContractInterface;
    public product: ProductInterface;
    public selectedProduct: SelectedProductInterface;
    private selectedProductOriginal: SelectedProductInterface;
    public onlyRefund = false;
    public editing = false;
    public readonly = true;
    public showModalOrders;
    public rol: string;
    public roleNames: RoleNameInterface[] = [];
    public meetingPage: boolean = false;
    public appropriatenessClient: ClientInterface;
    public canExonerate = false;

    constructor(
        private readonly operativePage: OperativePage,
        parentEvents: ParentEvents,
        private readonly dialog: MatDialog,
        private readonly getOperationUseCase: GetOperationUseCase,
        private readonly getOptimalSelectedProductUseCase: GetOptimalSelectedProductUseCase,
        private readonly localStorage: LocalStorage,
        private readonly router: Router,
        private readonly updateOperationUseCase: UpdateOperationUseCase,
        private readonly getRoleNameUseCase: GetRoleNameUseCase,
        private readonly getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        private readonly updateSelectedProductsUseCase: UpdateSelectedProductsUseCase,
        private readonly removeSelectedProductsUseCase: RemoveSelectedProductsUseCase
    ) {
        super(parentEvents);
        operativePage.showBackButton();
        this.backSubscription = operativePage.back.subscribe(() => {
            this.router.navigateByUrl(MainRoutes.OPERATIVE);
        });
    }

    get user(): UserInterface {
        return this.operativePage.user;
    }

    get showHasCampaign(): boolean {
        const startAt: moment.Moment = moment(AppConfig.settings.campaign.startAt, 'YYYY-MM-DD HH:mm:ss');
        const entAt: moment.Moment = moment(AppConfig.settings.campaign.endAt, 'YYYY-MM-DD HH:mm:ss');

        return (
            moment().isBetween(startAt, entAt, 'd', '[]') &&
            [OrderType.SUBSCRIPTION, OrderType.SUBSCRIPTION_PERIOD, OrderType.EXTERNAL_TRANSFER].indexOf(
                this.selectedProduct?.order.type
            ) !== -1
        );
    }

    ngOnInit() {
        this.getClientAndOperation();

        this.getRoleName();
        this.rol = localStorage.getItem('RolName');
    }

    get textCampaign(): string {
        return AppConfig.settings.campaign.textCampaign;
    }

    get urlCampaign(): string {
        return AppConfig.settings.campaign.urlCampaign;
    }

    private getClientAndOperation() {
        this.getAppropriatenessClientUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.appropriatenessClient = transaction.data as Client;
                this.canExonerate =
                    this.appropriatenessClient.mifidCategoryCode === MifidCategoryCode.MI ||
                    this.user.mifidCategoryCode === MifidCategoryCode.MI;
                this.getOperation();
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getRoleName() {
        this.getRoleNameUseCase
            .bind()
            .pipe(delay(1))
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.roleNames = transaction.data;
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    private getOperation() {
        this.showModalOrders = localStorage.getItem('HiddenOperations');
        localStorage.removeItem('HiddenOperations');
        this.getOperationUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (operation) => {
                    this.contract = operation.contract;
                    this.product = operation.product;
                    this.selectedProduct = operation.selectedProduct;

                    this.readonly = operation.readonly;
                    //Cambio hecho en ADV-4875
                    if (!this.selectedProduct.isAppropriateness) {
                        if (!this.readonly) {
                            this.selectedProduct.isExonerated = false;
                        }
                    }

                    this.selectedProductOriginal = cloneDeep(operation.selectedProduct);
                    this.allowedTypes = operation.types;
                    this.onlyRefund = operation.onlyRefund;
                    this.editing = operation.editing;

                    if (this.onlyRefund) {
                        this.product = operation.original.product;
                        this.selectedProduct = operation.original.selectedProduct;
                        this.selectedProductOriginal = cloneDeep(operation.original.selectedProduct);
                    }
                    if (!this.allowedTypes || this.allowedTypes.length === 0) {
                        this.showCanNotOperateModal();
                    } else {
                        //ADV-5661 - ADV-2351
                        /*
                        if (this.showModalOrders === 'true') {
                            const dialogRef = this.dialog.open(ConfirmOrderDialog, {
                                data: { text: 'dialog.confirm-not-available' },
                            });
                        }*/

                        if (!this.allowedTypes.find((it) => it.type === this.selectedProduct.order.type)) {
                            this.selectedProduct.order.type = this.allowedTypes[0].type;
                        }

                        if (this.localStorage.isExpiredDoc) {
                            this.showExpiredDocModal();
                        } else if (this.localStorage.isExpiredTest) {
                            this.showExpiredTestModal();
                        }
                    }
                },
                (throwable) => {
                    this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    });
                }
            );
        });
    }

    private showCanNotOperateModal(): void {
        const dialogRef = this.dialog.open(ErrorDialog, {
            data: { text: 'dialog.can-not-operate' },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
        });
    }

    private showExpiredDocModal(): void {
        const text = this.localStorage.clientNames.length > 1 ? 'operative.expired-doc-plural' : 'operative.expired-doc';
        this.dialog.open(ErrorDialog, {
            data: {
                type: 'info',
                text,
                textParams: {
                    client: this.localStorage.clientNames.join(', '),
                    expirationDate: this.localStorage.expirationDate || '',
                },
            },
        });
    }

    private showExpiredTestModal(): void {
        let text =
            this.localStorage.clientNames.length > 1 ? 'operative.expired-test-convenience-plural' : 'operative.expired-test-convenience';
        if (this.contract.isAdvisoryModelSuitability()) {
            text = this.localStorage.clientNames.length > 1 ? 'operative.expired-test-plural' : 'operative.expired-test';
        }

        this.dialog.open(ErrorDialog, {
            data: {
                type: 'info',
                text,
                textParams: {
                    client: this.localStorage.clientNames.join(', '),
                    expirationDate: this.localStorage.expirationDate || '',
                },
            },
        });
    }

    ngOnDestroy(): void {
        this.backSubscription.unsubscribe();
    }

    onDetail() {
        this.localStorage.step = 99;
        this.localStorage.write();

        window.open(MainRoutes.OPERATIVE_PRODUCTS_DETAIL.replace(':id', encodeURIComponent(String(this.product.encryptedCode))), '_blank');
    }

    onChangeOrderType(event: MatSelectChange) {
        const dialogRef = this.dialog.open(ConfirmDialog, {
            data: { text: 'dialog.confirm-order-type' },
        });

        const newValue = event.value;
        event.source.writeValue(this.selectedProduct.order.type);

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                let updateValue = true;

                if (!this.allowedTypes.find((it) => it.type === newValue)?.available) {
                    if (newValue === OrderType.SUBSCRIPTION_PERIOD) {
                        updateValue = false;
                        this.dialog.open(ErrorDialog, {
                            data: {
                                text: 'dialog.operate.subscription_period',
                                type: 'info',
                            },
                        });
                    } else if (newValue === OrderType.REFUND_PERIOD) {
                        updateValue = false;
                        this.dialog.open(ErrorDialog, {
                            data: {
                                text: 'dialog.operate.refund_period',
                                type: 'info',
                            },
                        });
                    }
                }

                if (updateValue) {
                    this.selectedProduct = cloneDeep(this.selectedProductOriginal);
                    this.selectedProduct.order.type = newValue;
                    event.source.writeValue(newValue);
                }
            }
        });
    }

    onDownload(url: string) {
        if (url.indexOf('http') !== 0) {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(Base64.toBlob(url));
            } else {
                window.open(URL.createObjectURL(Base64.toBlob(url)), '_blank');
            }
        } else {
            window.open(url, '_blank');
        }
    }

    onCancel() {
        this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
    }

    quitarAcentos(texto) {
        const acentos = { á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u', Á: 'A', É: 'E', Í: 'I', Ó: 'O', Ú: 'U' };
        return texto
            .split('')
            .map((letra) => acentos[letra] || letra)
            .join('')
            .toString();
    }

    verificarRol() {
        if (this.rol && typeof this.rol === 'string') {
            let rolMinusculas = this.rol.toLowerCase();
            rolMinusculas = this.quitarAcentos(rolMinusculas);
            let rolNameNow;
            this.roleNames.forEach((rolName) => {
                rolNameNow = rolName.name.toLowerCase();
                rolNameNow = this.quitarAcentos(rolNameNow);
                if (rolNameNow === rolMinusculas) {
                    this.meetingPage = true;
                }
            });
        }
    }

    onSubmit() {
        this.verificarRol();
        if (
            this.selectedProduct.order.type === OrderType.SUBSCRIPTION ||
            this.selectedProduct.order.type === OrderType.SUBSCRIPTION_PERIOD
        ) {
            const dialogRef: any = this.dialog.open(ConfirmTransferDialog, {
                data: {
                    textParams: {
                        iban: this.product.iban,
                    },
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    const updateOperation = (product: SelectedProductInterface, redirect = true) => {
                        this.updateOperationUseCase
                            .bind({
                                selectedProduct: product,
                                clientCode: Id.fromString(this.localStorage.clientCode),
                            })
                            .subscribe((transaction) => {
                                transaction.fold(
                                    () => {
                                        if (redirect) {
                                            if (this.meetingPage && localStorage.getItem('advisoryModel') === 'C') {
                                                this.router.navigateByUrl(MainRoutes.MEETING_SIGN + (this.editing ? '?update=1' : ''));
                                            } else {
                                                this.router.navigateByUrl(MainRoutes.OPERATIVE_SIGN + (this.editing ? '?update=1' : ''));
                                            }
                                        } else {
                                            this.getOperation();
                                        }
                                    },
                                    (throwable) =>
                                        this.dialog.open(ErrorDialog, {
                                            data: { text: throwable.message },
                                        })
                                );
                            });
                    };

                    if (
                        this.selectedProduct.order.type === OrderType.SUBSCRIPTION ||
                        this.selectedProduct.order.type === OrderType.INTERNAL_TRANSFER
                    ) {
                        this.getOptimalSelectedProductUseCase.bind({ product: this.selectedProduct }).subscribe((transaction) => {
                            transaction.fold(
                                (optimalProduct) => {
                                    if (optimalProduct.isOptimal) {
                                        updateOperation(this.selectedProduct);
                                    } else {
                                        this.dialog.open(ErrorDialog, {
                                            data: { text: optimalProduct.message },
                                        });

                                        if (optimalProduct.isAppropriateness && optimalProduct.encryptedCode) {
                                            const replaceSelectedProduct = cloneDeep(this.selectedProduct);
                                            replaceSelectedProduct.productId = optimalProduct.id;
                                            replaceSelectedProduct.code = optimalProduct.code;
                                            replaceSelectedProduct.encryptedCode = optimalProduct.encryptedCode;
                                            replaceSelectedProduct.isin = optimalProduct.isin;
                                            replaceSelectedProduct.name = optimalProduct.name;
                                            updateOperation(replaceSelectedProduct, false);
                                        }
                                    }
                                },
                                (throwable) =>
                                    this.dialog.open(ErrorDialog, {
                                        data: { text: throwable.message },
                                    })
                            );
                        });
                    } else {
                        updateOperation(this.selectedProduct);
                    }
                }
            });
        } else {
            const updateOperation = (product: SelectedProductInterface, redirect = true) => {
                this.updateOperationUseCase
                    .bind({
                        selectedProduct: product,
                        clientCode: Id.fromString(this.localStorage.clientCode),
                    })
                    .subscribe((transaction) => {
                        transaction.fold(
                            () => {
                                if (redirect) {
                                    if (this.meetingPage && localStorage.getItem('advisoryModel') === 'C') {
                                        this.router.navigateByUrl(MainRoutes.MEETING_SIGN + (this.editing ? '?update=1' : ''));
                                    } else {
                                        this.router.navigateByUrl(MainRoutes.OPERATIVE_SIGN + (this.editing ? '?update=1' : ''));
                                    }
                                } else {
                                    this.getOperation();
                                }
                            },
                            (throwable) =>
                                this.dialog.open(ErrorDialog, {
                                    data: { text: throwable.message },
                                })
                        );
                    });
            };

            if (this.selectedProduct.order.type === OrderType.INTERNAL_TRANSFER) {
                this.getOptimalSelectedProductUseCase.bind({ product: this.selectedProduct }).subscribe((transaction) => {
                    transaction.fold(
                        (optimalProduct) => {
                            if (optimalProduct.isOptimal) {
                                updateOperation(this.selectedProduct);
                            } else {
                                this.dialog.open(ErrorDialog, {
                                    data: { text: optimalProduct.message },
                                });

                                if (optimalProduct.isAppropriateness && optimalProduct.encryptedCode) {
                                    const replaceSelectedProduct = cloneDeep(this.selectedProduct);
                                    replaceSelectedProduct.productId = optimalProduct.id;
                                    replaceSelectedProduct.code = optimalProduct.code;
                                    replaceSelectedProduct.encryptedCode = optimalProduct.encryptedCode;
                                    replaceSelectedProduct.isin = optimalProduct.isin;
                                    replaceSelectedProduct.name = optimalProduct.name;
                                    updateOperation(replaceSelectedProduct, false);
                                }
                            }
                        },
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    );
                });
            } else {
                updateOperation(this.selectedProduct);
            }
        }
    }

    showTerms() {
        this.dialog.open(TermsAndConditionsDialog, {
            data: this.selectedProduct.order.type,
        });
    }

    onExonerate(product: BaseProductInterface) {
        this.updateSelectedProductsUseCase.bind({ products: [product as SelectedProductInterface] }).subscribe((transaction) => {
            if (!transaction.isSuccess) {
                product.isExonerated = !product.isExonerated;
            }

            if (!transaction.isSuccess && !transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    verifyOrderType(order: OrderInterface): boolean {
        return (
            order.type === OrderType.SUBSCRIPTION ||
            order.type === OrderType.SUBSCRIPTION_PERIOD ||
            order.type === OrderType.EXTERNAL_TRANSFER ||
            order.type === OrderType.INTERNAL_TRANSFER
        );
    }

    goToTAE(isin: string) {
        const tae_url = AppConfig.settings.tae_url.replace('{isin}', isin);
        window.open(tae_url, '_blank');
    }
}
